require('./all')

//scss
import '../../scss/site/flat-category.scss'
//

require('lightgallery.js')

const bootstrap_collapse = require('bootstrap/js/dist/collapse');

var nav = document.getElementById('nav-menu-box')

nav.addEventListener('show.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.add('show')
})

nav.addEventListener('hide.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.remove('show')
})

// core version + navigation, pagination modules:
import Swiper, {Navigation} from 'swiper';
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation]);

//modal flats
var flat_items = document.getElementById('flat_categories').querySelector('.items')

Array.prototype.forEach.call(flat_items.querySelectorAll('.item'), function (item) {
    let id = item.getAttribute('data-id')

    var modal_el = document.getElementById('flatViewModal' + id),
        modal_flat = new bootstrap_modal(modal_el)

    item.addEventListener('mouseover', function () {
        Array.prototype.forEach.call(modal_el.querySelectorAll('picture'), function (picture) {
            // LazyLoad.load(picture);
            picture.innerHTML = picture.innerHTML.replace(/data-/gi, '');
        })
    })

    modal_el.addEventListener('shown.bs.modal', function () {
        // setTimeout(function (){
        //

        Array.prototype.forEach.call(modal_el.querySelectorAll('picture'), function (picture) {
            // LazyLoad.load(picture);
            picture.innerHTML = picture.innerHTML.replace(/data-/gi, '');
        })

        if (!modal_el.querySelector('.swiper-container-initialized')) {

            var mySwiper = new Swiper('#flatViewModal' + id + ' .swiper-container', {
                loop: true,
                navigation: {
                    nextEl: '.next',
                    prevEl: '.prev',
                },
            })
        }
        // }, 100)
    })

    item.addEventListener('click', () => {
        modal_flat.show()
    })
})
